import { SlideNumber } from './SlideNumber';

export default function topConcertSlider() {
  const promiseTargets = {
    'js-inview': '-inview',
    'js-imageloaded': '-imageloaded',
  };
  const promiseTargetsKeys = Object.keys(promiseTargets);

  document.querySelectorAll('.js-topConcertSlider').forEach((element) => {
    const slideNodeList = element.querySelectorAll('.splide__slide');
    const slideProgress = element.querySelector('.splide-progress-bar');

    if (slideNodeList.length < 2) return;

    const splideInstance = new Splide(element, {
      mediaQuery: 'min',
      type: 'loop',
      focus: 'center',
      padding: '20%',
      gap: 25,
      rewind: true,
      speed: 1000,
      arrows: true,
      pagination: false,
      autoplay: true,
      interval: 4000,
      pauseOnHover: false,
      breakpoints: {
        769: {
          autoWidth: true,
          gap: 'min(4.0378006873vw, 47px)',
        },
      },
    });

    splideInstance.on('mounted move', function () {
      const end = splideInstance.Components.Controller.getEnd() + 1;
      const rate = Math.min((splideInstance.index + 1) / end, 1);
      slideProgress.style.width = `${String(100 * rate)}%`;
    });

    splideInstance.mount({
      SlideNumber,
    });

    if (splideInstance.options.autoplay) {
      if (promiseTargetsKeys.some((className) => element.closest(`.${className}`) !== null)) {
        splideInstance.Components.Autoplay.pause();

        const promiseItems = [];

        promiseTargetsKeys.forEach((className) => {
          promiseItems.push(
            new Promise((resolve) => {
              const targetElement = element.closest(`.${className}`);

              if (targetElement === null) resolve();

              const isDone = () => targetElement.classList.contains(`${promiseTargets[className]}`);

              if (isDone()) {
                resolve();
              } else {
                const observer = new MutationObserver(() => {
                  if (isDone()) {
                    observer.disconnect();
                    resolve();
                  }
                });

                observer.observe(targetElement, {
                  attributes: true,
                  attributeFilter: ['class'],
                });
              }
            }),
          );
        });

        Promise.all(promiseItems).then(() => {
          splideInstance.Components.Autoplay.play();
        });
      }
    }
  });
}
